import { createQueryKeys } from '@lukemorales/query-key-factory';

export const equipmentQueries = createQueryKeys('equipment', {
  // equipmentModelList: (params: IGetAiAgentModelListParams) => ({
  //   queryKey: [params.companyId, params.searchType, params.keyword, params.useYn, params.page, params.size],
  //   queryFn: async (): Promise<ApiResponse<IEquipmentModel>> => {
  //     const response = await aiAgentApis.model.getAiAgentModelList(params);
  //     return {
  //       count: response.data.totalCount,
  //       result: response.data.responses,
  //     };
  //   },
  // }),
});
